'use strict';

angular.module('loginModule')

.config(function (kdLoginProvider)
{
    kdLoginProvider.createLoginState({
        name: 'login',
        templateUrl: 'login/login.html',
    });

    kdLoginProvider.setAfterLoginState('admin.media');
})

.run(function ($rootScope, kdAuth, kdLogin, appConfig, $window)
{
    $rootScope.$on('kdAuth:userChanged', () =>
    {
        if (appConfig.theme.homeUrl) {
            if (kdAuth.user) {
                $window.location.href = appConfig.theme.homeUrl;
                return;
            }
        }

        let redirectState =  {
            name: appConfig.theme.homeState,
            params: {}
        };

        if (appConfig.basket.goto_home_after_login === 'first') {
            if (kdAuth.user && kdAuth.user.firstLogin) {
                kdLogin.redirectState = redirectState;
            }
        } else {
            kdLogin.redirectState = redirectState;
        }
    });
});
